import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress"; //顶部页面加载条
import "nprogress/nprogress.css"; //顶部页面加载条css
import pages from "./pages";

import store from '@/store'

NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3,
});
Vue.use(VueRouter);
//基本路由
const login = () => import("@/views/login/index.vue"); //登陆页
const layout = () => import("@/views/layout/index.vue"); //总体布局
const home = () => import("@/views/home/index.vue"); //首页
const indexView = () => import("@/views/home/indexView.vue"); //监控首页
const safeAccess = () => import("@/views/Venue_setting/safe-Access.vue"); //微信小程序出入场页面
const safeRiskcard = () => import("@/views/risk_identification/safe-app-riskcard.vue"); //微信小程序风险告知卡页面
const deviceInfo = () => import("@/views/device/device-app-info.vue"); //微信小程序查看设备信息

const filePreview = () => import("@/components/filePreview/index.vue");//文件预览页面

const err404 = () => import("@/views/error/404"); //404

const routes = [
  { path: "/login", name: "login", component: login, meta: { title: "登陆" } }, //登陆
  {
    path: "/homeView",
    name: "homeView",
    component: indexView,
    meta: { title: "监控平台", keepAlive: false,hasPermission:false, },
  }, //监控平台
  {
    path: "/safeAccess",
    name: "safeAccess",
    component: safeAccess,
    meta: { title: "出入场登记", hasPermission:false, },
  }, //微信出入场
  {
    path: "/safeRiskcard",
    name: "safeRiskcard",
    component: safeRiskcard,
    meta: { title: "风险告知卡", hasPermission:false, },
  }, //风险告知卡
  {
    path: "/filePreview",
    name: "filePreview",
    component: filePreview,
    meta: { title: "文件预览", hasPermission:false, },
  }, //文件预览
  {
    path: "/deviceInfo",
    name: "deviceInfo",
    component: deviceInfo,
    meta: { title: "设备信息", hasPermission:false, },
  }, //设备信息
  { path: "/404", component: () => import("@/views/error/404"), meta: { title: "404", keepAlive: false,hasPermission:false  }, hidden: true},
  {
    path: "/",
    name: "",
    hasPermission:false,
    meta: { hasPermission:false  },
    component: layout, //布局文件
    children: [
      { path: "/home", name: "home", component: home, meta: { title: "首页",hasPermission:false } }, //首页
      ...pages, //TODO:导入页面文件
    ],
  },

  //放在所有路由后面，不然会样式污染，未找到原因。
  {
    path: "/err404",
    name: "err404",
    component: err404,
    meta: { title: "404",hasPermission:false, },
  }, //404

  //这个*匹配必须放在最后，将改路由配置放到所有路由的配置信息的最后，否则会其他路由path匹配造成影响。
  { path: "*", redirect: "/404", hidden: true, meta: { hasPermission:false, }},
];

const router = new VueRouter({
  //开启哈希模式
//   mode: "history",
  routes,
});

// TODO: 路由守卫
router.beforeEach((to, from, next) => {
  NProgress.start(); //开启顶部进度条
  const tokenStr = window.localStorage.getItem("Authorization");
  
  //标题
  if (to.meta.title) {
    // document.title = to.meta.title;
    document.title = "广西矿山综合管控服务平台"; //此处写默认的title

  } else {
    document.title = "广西矿山综合管控服务平台"; //此处写默认的title
  }
console.log(to,'to');
    // 检查是否是外链菜单
    // if(to.hasOwnProperty('redirectedFrom') && to.redirectedFrom){
    //   let url = to.redirectedFrom.replace(/^\/+/, '');
    //   const isExte = isExternalLink(url);
    //   console.log(to);
    //   console.log(isExte,'外链');
    //   console.log(url,'url');
    //   if (isExte) {
    //     router.push({
    //       path: "/iframe",
    //       query: { url: encodeURIComponent(url) }
    //     });
    //   }
    // }
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // 访问登录页面 直接放行
  if (to.path === "/login" || to.path === "/safeAccess" || to.path === "/safeRiskcard" || to.path === "/deviceInfo" || to.path === "/filePreview" || to.path === "/iframe" ) return next();
  // 没有token， 强制转到login页面
  if (!tokenStr) return next("/login");
  console.log(to,'00000000000000000000000')
  if(to.meta.hasOwnProperty('hasPermission') && to.meta.hasPermission == false) return next();




 
  // 判断是否拥有跳转页面权限
  const hasPermission = checkPermission(store.state.roleArr,to.path);
  if (hasPermission) {
    next();
  } else {
    store.commit("delete_tabs", to.path);
    // 没有权限,提示错误信息或跳转到 403 页面
    // 这里可以根据实际需求进行处理
    next("/404");
  }
  next();
});
//判断是否为外部链接
function isExternalLink(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
};
// 检查用户是否有访问某个路由的权限
function checkPermission(data,path) {
  // 根据实际需求,编写权限判断的逻辑
  // 这里只是一个示例,实际需要根据您的业务逻辑进行实现
  for (let item of data) {
    if (item.path == path) {
      return true;
    }
    if (item.children && item.children.length > 0) {
      if (checkPermission(item.children,path)) {
        return true;
      }
    }
  }
  return false;
}

//路由跳转结束
router.afterEach(() => {
  NProgress.done(); //关闭顶部进度条
});

//解决重复点击当前路由跳转时报错信息。原因是vue-cli版本BUG，3.0版本无此BUG，往上时需要添加以下方法。
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
export default router;
